import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-leo-golden",
  "use": "icon-leo-golden-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-leo-golden\">\r\n<g transform=\"translate(-176.128 -108.928) scale(1.344000)\">\r\n<path d=\"M512 160l96 192 224 32-160 156 40 224L512 656 312 764l40-224L192 384l224-32L512 160z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/leo-golden.svg
// module id = pXdM
// module chunks = 478